import { ParamInfo } from '../../core/index.model';
import { Actions, CLEAR_PARAMETER, CREATE_PARAMETER, UPDATE_PARAMETER } from '../action/parameter.actions';

export function reducer(
    state: ParamInfo[] =[],
    action: Actions
)
{
    switch(action.type)
    {
        case CREATE_PARAMETER:
            {
                return [...state, action.payload];
            }
        case UPDATE_PARAMETER:
            {
                return state.map(paramObject => {
                    return Object.assign(paramObject, action.payload);
                });
            }
        case CLEAR_PARAMETER:
            {
                return Object.assign({}, state);
            }
    }
}




// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/statemanagement/reducer/parameter.reducer.ts